import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";

import { TeamOutlined } from '@ant-design/icons';
import Employees from "./index";
import ViewEmployee from "./view";
import EditEmployee from "./edit";
import ViewAccount from "../view";
import { MODULE_ACCT_EMPLOYEE } from "variables/constants";

const employeeRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Employees",
		basePath: "accounts/:accountId/employees",
		mainComponent: <ViewAccount />,
	    layout: "/console",	   
	    icon: <TeamOutlined className="h-6 w-6" />,
	    subTitle:"Employee",
	    viewComponent: <ViewEmployee />,
	    createComponent: <EditEmployee />,
	    editComponent: <EditEmployee />,
		isMainMenu:false,
		level: 2,
		moduleId: MODULE_ACCT_EMPLOYEE,
	})
]

export default employeeRoutes;